import {
  GET_WORKORDER_ITEMS,
  GET_WORKORDER_ITEMS_SUCCESS,
  GET_WORKORDER_ITEMS_FAIL,
  ADD_WORKORDER_ITEM,
  ADD_WORKORDER_ITEM_SUCCESS,
  ADD_WORKORDER_ITEM_FAIL,
  UPDATE_WORKORDER_ITEM,
  UPDATE_WORKORDER_ITEM_SUCCESS,
  UPDATE_WORKORDER_ITEM_FAIL,
  DELETE_WORKORDER_ITEM,
  DELETE_WORKORDER_ITEM_SUCCESS,
  DELETE_WORKORDER_ITEM_FAIL,
  SET_WORKORDER_ITEM_FIELD_ERRORS,
} from './actionTypes'

// Get WorkOrder Items
export const getWorkOrderItems = () => ({
  type: GET_WORKORDER_ITEMS,
})

export const getWorkOrderItemsSuccess = (workOrderItems) => ({
  type: GET_WORKORDER_ITEMS_SUCCESS,
  payload: workOrderItems,
})

export const getWorkOrderItemsFail = (error) => ({
  type: GET_WORKORDER_ITEMS_FAIL,
  payload: error,
})

// Add WorkOrder Item
export const addWorkOrderItem = (workOrderItem) => ({
  type: ADD_WORKORDER_ITEM,
  payload: workOrderItem,
})

export const addWorkOrderItemSuccess = (workOrderItem) => ({
  type: ADD_WORKORDER_ITEM_SUCCESS,
  payload: workOrderItem,
})

export const addWorkOrderItemFail = (error) => ({
  type: ADD_WORKORDER_ITEM_FAIL,
  payload: error,
})

// Update WorkOrder Item
export const updateWorkOrderItem = (workOrderItem) => ({
  type: UPDATE_WORKORDER_ITEM,
  payload: workOrderItem,
})

export const updateWorkOrderItemSuccess = (workOrderItem) => ({
  type: UPDATE_WORKORDER_ITEM_SUCCESS,
  payload: workOrderItem,
})

export const updateWorkOrderItemFail = (error) => ({
  type: UPDATE_WORKORDER_ITEM_FAIL,
  payload: error,
})

// Delete WorkOrder Item
export const deleteWorkOrderItem = (id) => ({
  type: DELETE_WORKORDER_ITEM,
  payload: id,
})

export const deleteWorkOrderItemSuccess = (id) => ({
  type: DELETE_WORKORDER_ITEM_SUCCESS,
  payload: id,
})

export const deleteWorkOrderItemFail = (error) => ({
  type: DELETE_WORKORDER_ITEM_FAIL,
  payload: error,
})

// Set Field Errors
export const setWorkOrderItemFieldErrors = (errors) => ({
  type: SET_WORKORDER_ITEM_FIELD_ERRORS,
  payload: errors,
})
